import { phraseValidate } from '../utils/regex';
import i18next from 'i18next';
import { getPlainTextLength } from './textGenerations/replaceMeasurementSpaces';

export const validate = values => {
  const errors = {};

  // announcement_accommodations
  if (values.announcement_accommodations.length === 0) {
    errors.announcement_accommodations = i18next.t('validate_accommodations');
  }

  // name
  if (!values.name) {
    errors.name = i18next.t('announcement_validate');
  }

  // date
  if (!values.start_date) {
    errors.start_date = i18next.t('begin_activity_validate');
  }

  if (!values.end_date) {
    errors.end_date = i18next.t('end_activity_validate');
  }

  // organisations
  if (
    values.announcement_organizations.length === 0 &&
    !values.organization_all
  ) {
    errors.announcement_organizations = i18next.t('validate_organizations');
  }

  // tags
  if (values.tags.length === 0 && !values.tag_all) {
    errors.tags = i18next.t('validate_tags');
  }

  //  text
  if (getPlainTextLength(values.text) > 1000) {
    errors.text = i18next.t('text_length_validate');
  }

  return errors;
};
